var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade modal-fullscreen-menu",
      attrs: {
        id: "modalNavigation",
        role: "dialog",
        tabindex: "-1",
        onclick: "$('#modalNavigation').modal('hide')",
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "modal-dialog d-flex justify-content-center align-items-center flex-wrap flex-column",
        },
        [
          _vm.ShopService.shop
            ? _c(
                "nav",
                { staticClass: "list-group" },
                [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "list-group-item",
                        attrs: {
                          title: "Accueil",
                          href: _vm.ShopService.shop.ShopId,
                        },
                      },
                      [_vm._v("Accueil")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sortedPages, function (page) {
                    return _c("div", { key: page.id }, [
                      _c(
                        "a",
                        {
                          staticClass: "list-group-item",
                          attrs: { title: page.title, href: _vm.pageUrl(page) },
                        },
                        [_vm._v(_vm._s(page.title))]
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "list-group-item",
                        attrs: {
                          title: "Nous contacter",
                          href: _vm.ShopService.shop.ShopId + "/contact",
                        },
                      },
                      [_vm._v("Nous contacter")]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.ShopService.shop && _vm.ShopService.shop.reservation
            ? _c("div", { staticClass: "btnBlock" }, [
                _c(
                  "a",
                  {
                    staticClass: "featLink booking",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        return _vm.UiService.showReservationModal()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "icon-eatselfapp_calendar" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Réserver une table")]),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "close keepOpacity",
        attrs: { "aria-label": "Close", "data-dismiss": "modal" },
      },
      [_c("span", [_vm._v("+")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }